import { CartItem } from "../../../../../models/order/workflow/order-cart.model";
import { WirelessCartRule, WirelessCartRuleContext, WirelessCartRuleType } from "./wireless-cart-rules";

export class WirelessCartRuleEngine {
    private rules: WirelessCartRule[] = [];

    registerRule(rule: WirelessCartRule): void {
        this.rules.push(rule);
        // Sort by priority after each registration
        this.rules.sort((a, b) => a.priority - b.priority);
    }

    processCustomization(context: WirelessCartRuleContext, ruleType: WirelessCartRuleType = WirelessCartRuleType.Customization): boolean {
        const applicableRules = this.rules.filter(rule => rule.type === ruleType);
        for (const rule of applicableRules) {
            if (rule.condition(context)) {
                rule.execute(context);
            }
        }

        return true;
    }

    processAllCustomizations(contexts: WirelessCartRuleContext[], ruleType: WirelessCartRuleType = WirelessCartRuleType.Customization): CartItem[] {
        const allCartItems: CartItem[] = [];

        for (const context of contexts) {
            // Fresh cart items array for each customization
            context.cartItems = [];

            const ruleExecuted = this.processCustomization(context, ruleType);

            if (ruleExecuted && context.cartItems.length > 0) {
                allCartItems.push(...context.cartItems);
            }
        }

        return allCartItems;
    }

    getRegisteredRules(): string[] {
        return this.rules.map(rule => `${rule.priority}: ${rule.name}`);
    }
}